import { Close, Search } from "@mui/icons-material";
import { Modal } from "@mui/material";
import Styles from "./GnaAdmin.module.css";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AddAdmin from "../AddAdmin/AddAdmin";
import { getAdmins } from "../../../../Services/GNA/GetData";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CompanyUserSelection from "../CompanyUserSelection/CompanyUserSelection";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdmins,
  fetchCompany,
} from "../../../../Redux/Slices/gnaAdminSlice";
import {
  adminCompanyAccess,
  adminCompanyReassignAccess,
  handleDisableUser_Admin,
} from "../../../../Services/GNA/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";

const GnaAdmin = ({ open, handleClose }) => {
  const dispatch = useDispatch();
  const admins = useSelector(
    (state) => state?.gnaAdminSlice?.fetchAdmins?.data,
  );
  const [addModal, setAddModal] = useState(false);

  const [selction, setSelection] = useState(false);
  const [selId, setSelId] = useState({});
  const [selected, setSelected] = useState([]);

  const [editData, setEditData] = useState(null);

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmId, setConfirmId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    handleFetchAdmins();
  }, []);

  const handleFetchAdmins = async () => {
    dispatch(fetchAdmins());
  };

  const handleCompanySelection = async (data) => {
    const payload = data?.map((item) => ({
      companyId: item, // Copies all original properties from the 'item'
      adminUserId: selId?.userId,
      adminRole: selId?.userType,
    }));
    let res = await adminCompanyAccess(payload);
    if (res?.data?.code === 200) {
      handleFetchAdmins();
      dispatch(fetchCompany());
      setSelection(false);
    } else {
      ErrorMessage(res?.data?.error || "Failed to assign companies to admin");
    }
  };

  const handleCompanyDeSelection = async (data) => {
    const payload = data?.map((item) => ({
      companyId: item?.companyId || item, // Copies all original properties from the 'item'
      adminUserId: selId?.userId,
      adminRole: selId?.userType,
    }));
    let res = await adminCompanyReassignAccess(payload);
    if (res?.data?.code === 200) {
      handleFetchAdmins();
      dispatch(fetchCompany());
      setSelection(false);
    } else {
      ErrorMessage(res?.data?.error || "Failed to assign companies to admin");
    }
  };

  const handleUpdateCompanySelection = async (id) => {
    if (selected.includes(id)) {
      handleCompanyDeSelection([
        {
          companyId: id, // Copies all original properties from the 'item'
          adminUserId: selId?.userId,
          adminRole: selId?.userType,
        },
      ]);
      setSelected((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleEditClick = (data) => {
    setEditData(data);
    setAddModal(true);
  };

  const handleDeleteUser = async () => {
    let res = await handleDisableUser_Admin(confirmId);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      handleFetchAdmins();
      setConfirmDelete(false);
    } else {
      ErrorMessage(res?.data?.error);
    }
  };

  const filteredAdmins = (admins || []).filter((ele) =>
    ele?.fullName?.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const typeBadgeStyle = (type) => {
    const base = {
      display: "inline-block",
      padding: "2px 10px",
      borderRadius: "12px",
      fontSize: "11px",
      fontWeight: 600,
      letterSpacing: "0.5px",
    };
    if (type === "ADMIN")
      return { ...base, background: "#fff1eb", color: "#e07140", border: "1px solid var(--primary-color-text)" };
    if (type === "MAKER")
      return { ...base, background: "#f0f4ff", color: "#4a6cf7", border: "1px solid #a0b4f7" };
    if (type === "CHECKER")
      return { ...base, background: "#f0faf3", color: "#2e8b57", border: "1px solid #7ec8a0" };
    return base;
  };

  return (
    <>
      {addModal && (
        <AddAdmin
          open={addModal}
          handleClose={() => {
            setAddModal(false);
            setEditData(null);
          }}
          handleFetchAdmins={handleFetchAdmins}
          editData={editData}
        />
      )}

      {selction && (
        <CompanyUserSelection
          open={selction}
          handleClose={() => {
            setSelection(false);
            setSelected(null);
          }}
          selected={selected}
          type={"Company"}
          handleSubmit={handleCompanySelection}
          handleSelection={handleUpdateCompanySelection}
        />
      )}

      {confirmDelete && (
        <ConfirmationModal
          open={confirmDelete}
          handleClose={() => setConfirmDelete(false)}
          data={`Are you sure you want to delete admin?`}
          handleSubmit={handleDeleteUser}
        />
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.adminContainer}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.headingText}`}
          >
            <div className={`headingText ${Styles.finalHead}`}>
              GNA Admin(s)
            </div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.tableMainCont}>
            <div className={Styles.tableToolbar}>
              <div className={Styles.adminCount}>
                <span>Total Admins : </span>
                <b>{admins?.length}</b>
                {searchQuery && (
                  <span className={Styles.filteredCount}>
                    &nbsp;({filteredAdmins.length} shown)
                  </span>
                )}
              </div>
              <div className={Styles.toolbarRight}>
                <div className={Styles.searchBox}>
                  <Search style={{ fontSize: "16px", color: "#aaa" }} />
                  <input
                    className={Styles.searchInput}
                    type="text"
                    placeholder="Search by name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  {searchQuery && (
                    <Close
                      style={{ fontSize: "14px", color: "#aaa", cursor: "pointer" }}
                      onClick={() => setSearchQuery("")}
                    />
                  )}
                </div>
                <div
                  className={Styles.addAdminCntainer}
                  onClick={() => setAddModal(true)}
                >
                  <AddIcon style={{ fontSize: "16px" }} />
                  <span>Add Admin</span>
                </div>
              </div>
            </div>
            <div className={Styles.adminListsContainer}>
              <div className="display_flex_row tableHeading">
                <div style={{ width: "15%" }}>Name</div>
                <div style={{ width: "13%" }}>Username</div>
                <div style={{ width: "12%" }}>Phone</div>
                <div style={{ width: "20%" }}>Email</div>
                <div style={{ width: "12%" }}>Type</div>
                <div style={{ width: "18%" }}>Assigned Company</div>
                <div style={{ width: "10%" }}>Alter</div>
              </div>
              <div className={`scroll_bar_y ${Styles.adminListContainer}`}>
                {filteredAdmins.length === 0 ? (
                  <div className={Styles.emptyState}>
                    No admins found matching &ldquo;{searchQuery}&rdquo;
                  </div>
                ) : (
                  filteredAdmins.map((ele) => (
                    <div key={ele?.userId} className="display_flex_row tableDetails">
                      <div
                        title={ele?.fullName}
                        className="textOverflow"
                        style={{ width: "15%" }}
                      >
                        {ele?.fullName}
                      </div>
                      <div
                        title={ele?.userName}
                        className="textOverflow"
                        style={{ width: "13%" }}
                      >
                        {ele?.userName}
                      </div>
                      <div
                        title={ele?.phone}
                        className="textOverflow"
                        style={{ width: "12%" }}
                      >
                        {ele?.phone}
                      </div>
                      <div
                        title={ele?.email}
                        className="textOverflow"
                        style={{ width: "20%" }}
                      >
                        {ele?.email}
                      </div>
                      <div style={{ width: "12%" }}>
                        <span style={typeBadgeStyle(ele?.userType)}>
                          {ele?.userType}
                        </span>
                      </div>
                      <div className="textOverflow" style={{ width: "18%" }}>
                        {ele?.assignedCompanies?.length === 0 ? (
                          <PersonAddIcon
                            style={{
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "var(--primary-color-text)",
                            }}
                            onClick={() => {
                              setSelection(true);
                              setSelId(ele);
                            }}
                          />
                        ) : (
                          <div className="display_flex_row_gap_8">
                            <span className={Styles.companyCount}>
                              {ele?.assignedCompanies?.length}
                            </span>
                            <VisibilityIcon
                              style={{
                                fontSize: "16px",
                                cursor: "pointer",
                                color: "var(--primary-color-text)",
                              }}
                              onClick={() => {
                                setSelection(true);
                                setSelId(ele);
                                setSelected(
                                  ele?.assignedCompanies?.map(
                                    (item) => item?.companyId,
                                  ),
                                );
                              }}
                            />
                          </div>
                        )}
                      </div>
                      <div
                        style={{ width: "10%" }}
                        className={`display_flex_row_gap_8 ${Styles.actionButtons}`}
                      >
                        <button
                          className={Styles.editBtn}
                          title="Edit"
                          onClick={() => handleEditClick(ele)}
                        >
                          <BorderColorIcon style={{ fontSize: "13px" }} />
                        </button>
                        <button
                          className={Styles.deleteBtn}
                          title="Delete"
                          onClick={() => {
                            setConfirmDelete(true);
                            setConfirmId(ele?.userId);
                          }}
                        >
                          <DeleteIcon style={{ fontSize: "13px" }} />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default GnaAdmin;
